import { Card } from "@conuti-das/prince-ui";
import "@/styles/accents.css";
import "./ki-einsatz.css";

type KiPoint = { context: string; tool: string; desc: string };

/** Übernommen aus der bisherigen Pitch-Slide „Wo setzen wir KI ein" (AI-Blöcke). */
const KI_POINTS: KiPoint[] = [
  { context: "Wartungs-Team", tool: "KI-Skills", desc: "Regulatorik automatisiert in ein deploybares Code-Toolset überführen." },
  { context: "MACO APP", tool: "Marktprozess-Engine (MPS)", desc: "BPMN-Runtime mit KI-gestützter Prozesssteuerung." },
  { context: "MACO APP", tool: "Technische Marktkommunikation (MCS)", desc: "KI im EDIFACT-Mapping über AS4 / MAIL / API." },
  { context: "MACO APP", tool: "Adapter Business System", desc: "KI-gestützte Anbindung an ERP / CRM." },
  { context: "MACO APP", tool: "Übergreifende Dienste", desc: "Cross-Component-Services mit KI-Unterstützung." },
  { context: "Betrieb", tool: "KI-Agent Dunkelverarbeitung", desc: "Autonome Bearbeitung von Klärfällen." },
  { context: "Betrieb", tool: "KI-Agent Fehleranalyse", desc: "Root-Cause- und Fehlermuster-Erkennung." },
];

/** „Wo setzen wir KI ein" — modernisierte Sektion unter dem Architektur-Haus. */
export function KiEinsatz() {
  return (
    <section className="ki-einsatz" aria-labelledby="ki-einsatz-h">
      <div className="ki-einsatz-head">
        <span className="accent-dot" aria-hidden="true" />
        <h3 id="ki-einsatz-h">Wo setzen wir KI ein</h3>
      </div>
      <div className="ki-einsatz-grid">
        {KI_POINTS.map((p, i) => (
          <Card key={i} padding="regular" className="ki-card">
            <article>
              <div className="ki-card-context">{p.context}</div>
              <div className="ki-card-tool">{p.tool}</div>
              <p className="ki-card-desc">{p.desc}</p>
            </article>
          </Card>
        ))}
      </div>
    </section>
  );
}
